import { useContext } from 'react'
import HeroModuleContext from '@contexts/heroModuleContext'

const useIsInHeroModule = (): boolean => !!useContext(HeroModuleContext)

export default useIsInHeroModule
